module.exports = __webpack_public_path__ + "img/logo-icon.37eba5ca.png";